<template>
  <q-page fluid>
    <div class="row full-width">
      <div class="col-12">
        <q-card class="full-width">
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Surf Life Saving NZ
              </div>
              <q-space />
            </div>
          </q-card-section>

          <q-separator />

          <q-card-section class="formHeight q-pa-none">
            <q-btn @click="startNFCScanner">{{
              ndef ? "NFC SCANNER RUNNING" : "NFC RECONCILE SCANNER START"
            }}</q-btn>
            <q-scroll-area style="height: calc(100vh - 315px) !important">
              <slsnzForm
                ref="editForm"
                :data="viewFormData"
                @close="viewDetailsDialog = false"
                @loadingStateChanged="state => (saveLoading = state)"
              />
            </q-scroll-area>
          </q-card-section>
          <q-card-section>
            <div class="row">
              <div class="col-12">
                <q-btn
                  @click="$refs.editForm.save()"
                  :loading="saveLoading"
                  color="primary"
                  no-caps
                  class="float-right"
                >
                  <q-icon
                    name="mdi-content-save"
                    color="white"
                    class="q-mr-sm"
                    size="xs"
                  ></q-icon>
                  Save
                </q-btn>
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import slsnzForm from "@/components/slsnz/slsnzForm.vue";
import { NFCScan, NFCWrite } from "@/plugins/NFC";

export default {
  components: {
    slsnzForm
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData"
    })
  },
  watch: {},
  data: () => ({
    viewFormData: {},
    saveLoading: false,
    viewDetailsDialog: false,

    nfcScanner: null,

    ndef: null,
    handleReading: null
  }),
  mounted() {},
  unmounted() {
    this.ndef.removeEventListener("reading", this.handleReading);
  },
  methods: {
    async handleNFCScan(message, serialNumber, extraData) {
      try {
        const data = message.records[0].data;
        const textDecoder = new TextDecoder("utf-8");
        const text = textDecoder.decode(data);
        console.log(text);
        let payload = {
          id: text.split(" - ")[1],
          serialNumber: serialNumber
        };
        let response = await this.$store.dispatch("NFC/nfcReconcile", payload);
        console.log(response);
        if (response.Response.Result) {
          this.$q.notify({
            position: "top-right",
            type: response.Response.Result ? "positive" : "negative",
            message: response.Response.Result
              ? `Tag Assigned to ${text.split(" - ")[0]}`
              : response.Response.Message
          });
        }
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later"
        });
      }
    },
    async startNFCScanner() {
      const { ndef, handleReading } = await NFCScan(
        this,
        this.handleNFCScan,
        null
      );
      this.ndef = ndef;
      this.handleReading = handleReading;
    }
  }
};
</script>

<style lang="scss" scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}

.formHeight {
  min-height: calc(100vh - 215px);
  max-height: 1000px;
}
</style>
